<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph"><i>My child, eat honey, for it is good</i></p>
<p class="noind"><i>and the drippings of the</i></p>
<p class="noind"><i>honeycomb are sweet to</i></p>
<p class="noind"><i>your taste.</i></p>
<p class="noind"><i>Know that wisdom is such to</i></p>
<p class="noind"><i>your soul;</i></p>
<p class="noind"><i>if you find it, you will find a future,</i></p>
<p class="noind"><i>and your hope will not be cut off.</i></p>
<p class="noind">—Proverbs 24:13–14</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph.vue?6c8ae140